import { TAppState } from '../../types/appState';
import { TCustomAction } from '../../types/customActions';
import { currentOpenChatIDSelector } from '../currentOpenChatIDSelector';

export function customActionsSelector(state: TAppState): TCustomAction[] | null {
  const { chatList } = state;

  const currentOpenedChatId = currentOpenChatIDSelector(state);

  const currentChatListItem = chatList.chats.find(chat => chat.chatId === currentOpenedChatId);

  return currentChatListItem && currentChatListItem.customActions
    ? (currentChatListItem.customActions as TCustomAction[])
    : null;
}
